export const MAX_PAGINATION_PAGE = 50;
export const MAX_LISTING_PAGE = 25;

export const normalizePaginationPage = (
  page: unknown,
  maxPage: number = MAX_PAGINATION_PAGE,
) => {
  const parsedMaxPage = Number(maxPage);
  const safeMaxPage = Number.isFinite(parsedMaxPage)
    ? Math.min(Math.max(Math.floor(parsedMaxPage), 1), MAX_PAGINATION_PAGE)
    : 1;
  const parsedPage = Number(page);

  return Number.isFinite(parsedPage)
    ? Math.min(Math.max(Math.floor(parsedPage), 1), safeMaxPage)
    : 1;
};

export const isValidPageParam = (values: string[]) => {
  if (!values.length) return true;
  if (values.length > 1 || !/^\d+$/.test(values[0])) return false;

  const page = Number(values[0]);
  return page >= 1 && page <= MAX_LISTING_PAGE;
};

export const getCanonicalPage = (page: unknown) => {
  const safePage = normalizePaginationPage(page, MAX_LISTING_PAGE);
  return safePage > 1 ? String(safePage) : undefined;
};

export const getTotalPages = ({
  totalJobs = 0,
  jobsOnPage,
  currentPage,
  limit = 10,
}: {
  totalJobs?: number;
  jobsOnPage: number;
  currentPage: number;
  limit?: number;
}) => {
  const totalPages = Math.min(MAX_LISTING_PAGE, Math.max(1, Math.ceil(totalJobs / limit)));

  return jobsOnPage < limit ? Math.min(totalPages, currentPage) : totalPages;
};
